





















import config from '@/config'
import { IWallet } from '@/typings'
import Getters from '@/mixins/Getters'
import { Component, Mixins, Watch } from 'vue-property-decorator'

@Component
export default class Wallet extends Mixins(Getters) {
  get addressUrl(): string {
    return `${config.explorerBaseUrl}/address/${this.address}`
  }

  // Enable loading indicator on Seed / PK change

  @Watch('dataStore.mnemonic')
  @Watch('dataStore.privateKey')
  protected onProviderChange(value: string) {
    if (value) { this.uiStore.commitIsLoading(true) }
  }

  // Disable loading indicator if Seed / PK is correct

  @Watch('dataStore.wallet')
  protected onWalletChange(value: IWallet | null) {
    if (value) { this.uiStore.commitIsLoading(false) }
  }

  // Disable loading indicator on Seed / PK error

  @Watch('dataStore.error')
  protected onErrorChange(value: Error | null) {
    if (value) { this.uiStore.commitIsLoading(false) }
  }
}
